import { useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import { Button, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import NotificationsList from "../../features/manageNotifications/notificationsList";
import AddIcon from '@mui/icons-material/Add';
import Can from "../../components/Can";
import CommonBreadcrumb from "../../components/CommonBreadcrumb";
import React from "react";
import { NOTIFICATION_TYPE } from "../../constants/enum";

const ManageNotifications = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [type, setType] = React.useState('default');
  const [page, setPage] = useState(1);

  const handleTypeChange = (event: SelectChangeEvent) => {
    setType(event.target.value as string);
    setPage(1);
  };

  return (
    <>
      <CommonBreadcrumb
        title="Notification Management"
        breadcrumbItems={[
          { label: "Dashboard", onClick: () => navigate("/dashboard") },
          { label: "Notification Management" },
        ]}
      />

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
            <div className="form">
              <div className="control_group">
                <Select
                  fullWidth
                  value={type}
                  onChange={handleTypeChange}
                >
                  <MenuItem disabled value="default">Select Type</MenuItem>
                  <MenuItem value={NOTIFICATION_TYPE.BROADCAST}>Broadcast</MenuItem>
                  <MenuItem value={NOTIFICATION_TYPE.EMAIL}>Email</MenuItem>
                  <MenuItem value={NOTIFICATION_TYPE.PUSH}>Push Notification</MenuItem>
                </Select>
              </div>
            </div>
          </div>
          <div className="right_s">
            <Can module="Notification Management" action="isAdd" isDisabledMode={true}>
              <Button className="btn btn_primary" onClick={() => navigate("/manage-notifications/add")}><AddIcon /> Add Notification</Button>
            </Can>
          </div>
        </div>

        <NotificationsList 
          searchTerm={searchTerm} 
          type={type} 
          page={page} 
          setPage={setPage} 
        />
      </div>
    </>
  );
};

export default ManageNotifications;
